<template>
  <ob-modal2 :show.sync="show" :width="750" :backdrop="false">
    <template slot="modal-title">
        <span> Invoicing Details </span>
        <div class="invoice-page">  <span> {{currentIndex + 1}} </span> <span> of  {{missingInvoiceDetails.length}} </span></div>
    </template>
    <template slot="modal-body">
      <template v-for="(invoice,index) in missingInvoiceDetails">
      <div class="invoice-body" v-if="currentIndex == index" v-bind="invoice.Id">
        <div class="row mL0 mR0">
          <div class="form-group col-md-4">
            <label>Employee Name</label>
            <label class="LblContent">{{NAOrValue(invoice, 'Name')}}</label>
          </div>
          <div class="form-group col-md-4">
            <label>Poject Title</label><br>
             <label class="LblContent">{{NAOrValue(invoice, 'ProjectTitle')}}</label>
          </div>
        </div>
          <div style="border-bottom: 1.2px dashed rgb(221, 221, 221);" class="row mL0 mR0">
          <div class="form-group col-md-4">
            <label>Client Organization Name</label><br>
            <label class="LblContent">{{NAOrValue(invoice, 'ClientOrganizationName')}}</label>
          </div>
          <div class="form-group col-md-4">
            <label>Client Contact Name</label><br>
            <label class="LblContent">{{NAOrValue(invoice, 'ClientContactName')}}</label>
          </div>
           <div class="form-group col-md-4">
            <label>Client Contact Email Address</label><br>
            <label class="LblContent">{{NAOrValue(invoice, 'ClientContactEmail')}}</label>
          </div>
        </div>
        <p style="font-size:13px;font-weight:600;padding:10px">The following details are needed for invoicing generation.The information added below will be updated in the respective project as well.</p>
        <div style="padding-bottom: 15px;" class="col-md-12  check_box">
            <ob-checkbox v-model="invoice.IsSameAsClientContact" @change.native="InvoiceDetailsCheckboxClick(index)" :val="true">Invoicing contact same as client contact.</ob-checkbox>
        </div>
        <div  style="border-bottom: 1.2px dashed rgb(221, 221, 221);padding-top: 15px;" class="row mL0 mR0">
          <div class="form-group col-md-4">
            <label>Invoicing Contact Name</label><span class="validation-star">*</span>
            <ob-input v-on:keyup.native="clearValues()" v-model="invoice.InvoiceContactName" placeholder="Full Name" ></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="isValid">Enter Invoicing Contact Name</span>
          </div>
          <div class="form-group col-md-4">
            <label>Invoicing Contact Email ID</label>
            <ob-input v-model="invoice.InvoiceContactEmailId" placeholder="Email ID"  ></ob-input>

          </div>
          <div class="form-group col-md-4">
            <label>Invoicing Contact Phone Number</label>
            <ob-input v-model="invoice.InvoiceContactPhoneNumber"  v-phone-number placeholder="Phone Number"  ></ob-input>
          </div>
        </div>
        <div style="padding-top: 15px;" class="row  mL0 mR0">
          <div class="form-group col-md-4">
            <label>Bill Rate </label><span class="validation-star">*</span>
            <ob-input v-on:keyup.native="clearValues()" v-model="invoice.BillRate"  placeholder="Enter Bill Rate" ></ob-input>
            <span class="ob-vuelidate_error-msg" v-if="IsBillGraterZero">Bill Rate Grater Than Zero</span>
          </div>
        </div>
      </div>
      </template>
    </template>
    <template slot="modal-footer">
      <ob-button v-if="currentIndex == 0" type="secondary" @click="cancel()" >Cancel</ob-button>
      <ob-button v-else type="secondary" @click="currentIndex--" >Back</ob-button>

      <ob-button @click="onNextButtonClick()" v-if="currentIndex != missingInvoiceDetails.length-1">Next</ob-button>
       <ob-button v-else @click="GenerateInvoice()">Generate</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators'
const phoneNumber = (value) => {
  var phone = /^[0-9 +()-]+$/i
  return phone.test(value)
}
export default {
  props: ["showModal","selectedTimeIds","missingInvoiceDetails"],
  data() {
    return {
     IsBillGraterZero : false,
     IsBillValid : false,
     isValid : false,
     show: false,
     currentIndex:0,
     totalIndex:0,

    }
  },
  validations() {
    return{
       invoice:{
          InvoiceContactName:{
            required
          }
       }
    }
  },
  watch:{
    showModal(val){
      this.show = val
    },
     show(val) {
          this.$emit('update:showModal', val)
      },
  },
  created(){
    this.show = this.showModal
  },
  computed:{

  },
  methods:{
    clearValues(){
    if(this.missingInvoiceDetails[this.currentIndex].InvoiceContactName != ''){
       this.isValid = false;
    }
     if(this.missingInvoiceDetails[this.currentIndex].BillRate != 0){
       this.IsBillGraterZero = false;
     }
      
    },
    InvoiceDetailsCheckboxClick(index)
    {
      if(this.missingInvoiceDetails[index].IsSameAsClientContact && this.missingInvoiceDetails[index].ClientContactName != '')
      {
          this.clearValues()
          this.missingInvoiceDetails[index].InvoiceContactName = this.missingInvoiceDetails[index].ClientContactName;
          this.missingInvoiceDetails[index].InvoiceContactEmailId = this.missingInvoiceDetails[index].ClientContactEmail; 
          this.missingInvoiceDetails[index].InvoiceContactPhoneNumber  = this.missingInvoiceDetails[index].ContactPhoneNumber;
      }
    },
    GenerateInvoice()
    {
      if(this.missingInvoiceDetails[this.currentIndex].InvoiceContactName == '' || this.missingInvoiceDetails[this.currentIndex].InvoiceContactName == null  ){
         this.isValid = true; 
      }
      if(this.missingInvoiceDetails[this.currentIndex].BillRate == 0){
        this.IsBillGraterZero = true
      }
      else{
        this.isValid = false;
        this.IsBillGraterZero = false;
        this.$parent.$parent.generateInvoice(this.missingInvoiceDetails);
      }
    },
    onNextButtonClick()
    {
        // let nextPageIndex = this.currentIndex + 1
        //  this.missingInvoiceDetails[nextPageIndex].InvoiceContactName = ""
        //  this.missingInvoiceDetails[nextPageIndex].InvoiceContactEmailId = ""
        //  this.missingInvoiceDetails[nextPageIndex].InvoiceContactPhoneNumber  = ""
      if(this.missingInvoiceDetails[this.currentIndex].InvoiceContactName == '' || this.missingInvoiceDetails[this.currentIndex].InvoiceContactName == null  ){
        this.isValid = true;
      }
      if(this.missingInvoiceDetails[this.currentIndex].BillRate == 0){
        this.IsBillGraterZero = true
      }
      else{
         this.currentIndex++;
         this.isValid = false;
         this.IsBillGraterZero = false;
      }
    },
     cancel(){
      this.show = false
      this.$emit('close')
    },



  }
}
</script>
<style lang="scss" scoped>
.LblContent{
    font-size: 14px;
    font-weight: 600 !important;
    display: block;
}
.invoice-page{
    display: inline-block;
    float: right;
    margin-right: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/EditInvoiceDetails.vue